import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import { titanApi, useGetTraggliedDatenQuery } from "../../../services/API/titanApi";
import { selectBemessungenMikropfaehle } from "../../../store/slices/bemessungenMikropfaehleSlice";
import { selectBemessungslast } from "../../../store/slices/bemessungslastSlice";
import {
  selectCarryingElementErrorInNachweis,
  selectDisplayUtilizationError,
} from "../../../store/slices/innereSlice";
import { selectTraggliedTitle, setSelectedTragglied } from "../../../store/slices/traggliedSlice";

const DesignLoadSelection = () => {
  const dispatch = useDispatch();
  const bemessungslast = useSelector(selectBemessungslast);

  const traggliedName = useSelector(selectTraggliedTitle);
  const { data: traggliedDaten } = useGetTraggliedDatenQuery(traggliedName);
  const showError = useSelector(selectDisplayUtilizationError(traggliedDaten));
  const bemessungenMikropfaehle = useSelector(selectBemessungenMikropfaehle);
  const [allElements, setAllElements] = useState([]);

  // TODO: Add to slice
  const [trigger, { isLoading, isError }] =
    titanApi.endpoints.getCarryElements.useLazyQuerySubscription();

  function getBemessungslast() {
    if (isNaN(bemessungslast)) return 0;
    if (bemessungslast === null) return 0;

    return bemessungslast;
  }

  useEffect(() => {
    trigger({ fd: getBemessungslast(), type: bemessungenMikropfaehle })
      .catch((e) => console.error(e))
      .then((result) => {
        setAllElements(result.data);
        if (!result.data.some((e) => e?.name === traggliedName)) {
          setAllElements(result.data);
          dispatch(setSelectedTragglied(result.data[0]?.name));
        }
      });
  }, [bemessungslast]);

  const NachweisError = useSelector(selectCarryingElementErrorInNachweis);
  return (
    <div className={NachweisError ? "change-input-error" : ""}>
      {/* {isLoading && <div className="spinner-grow" role="status" />} */}
      {isError && <h1 className="red">Error</h1>}
      <select
        value={traggliedName}
        className={showError ? "change-input-error" : "change-input"}
        name="tragglied-value"
        id="tragglua"
        onChange={(e) => {
          dispatch(setSelectedTragglied(e.target.value));
        }}
      >
        {allElements?.map((el, index) => {
          return (
            <option key={index} value={el?.name}>
              {el?.name}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default DesignLoadSelection;
